"use client"

import Link from "next/link"

import { ColdApproachWordmark } from "@/components/marketing/cold-approach-wordmark"

// The stripped one-line funnel footer: the lockup, Contact, and the two
// legal pages - no newsletter ask and no navigation wall
// for a booked prospect. This is the COMPONENT of the footers.funnel module
// instance; route selection lives in the layout's ChromeSwitch, never here.
const FUNNEL_LINKS = [
  { href: "/contact", label: "Contact" },
  { href: "/privacy-policy", label: "Privacy Policy" },
  { href: "/terms-and-conditions", label: "Terms & Conditions" },
] as const

export function FunnelFooter() {
  return (
    <footer style={{ backgroundColor: "var(--color-ink-lifted)" }} className="px-5 py-8 text-white sm:px-8">
      <div className="mx-auto flex max-w-[92rem] flex-col items-center gap-4 sm:flex-row sm:justify-between">
        <ColdApproachWordmark size={80} decorative />
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          {FUNNEL_LINKS.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="tap-target text-[0.8125rem] text-white/60 transition-colors hover:text-white"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </footer>
  )
}
